export default __webpack_public_path__ + "static/munoz-72a9bb25bd42ace2661b63d1ebb8700c.jpg";